<template>
  <div class="yuanbao-author-rule-wrap">
    <div class="hd">
      <span class="btn-close" @click="handleClosePage" />
    </div>
    <div class="bd">
      <dl>
        <dt>1. 免费下载</dt>
        <dd>·用户可直接下载您上传的壁纸。</dd>
        <dt>2. 付费下载</dt>
        <dd>·用户需要使用鱼干购买/开通VIP才能下载您上传的壁纸。</dd>
        <dd>·若用户使用鱼干赞赏了您设置为需赞赏才能使用的壁纸，扣除60%的平台管理费用后，所得收益全部归您所有（1鱼干=1元宝）；</dd>
        <dd>·若用户以vip身份使用了需赞赏才能使用的壁纸（次月通过vip权益使用独立版或合作版的壁纸，您将再次获得收益）， 针对每张需赞赏的壁纸，您可获得的元宝收益如下表所示（最终的获得的元宝收益为整数，并会按照下表进行四舍五入处理）：</dd>
        <!-- <dd id="exchange-list-desc">
          针对每张付费壁纸，您可获得的元宝收益如下表所示：
        </dd> -->
        <dd>
          <div class="sub">
            <ExchangeList />
          </div>
        </dd>
        <dt>3. 观看广告下载（仅支持手机版壁纸）</dt>
        <dd>·用户需要观看视频广告才能下载您上传的壁纸。</dd>
        <dd>·每次下载壁纸时播放视频广告产生的收入，扣除40%平台管理费后，全部归上传者所有。</dd>
        <dd>·观看广告下载仅支持手机版壁纸，若您同时上传了电脑/手机版则电脑壁纸会设为免费壁纸</dd>
      </dl>
    </div>
  </div>
</template>

<script>
import ExchangeList from '@/components/ExchangeList'

export default {
  name: 'YuanbaoAuthorRuleCenter',
  components: {
    ExchangeList,
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  methods: {
    handleClosePage() {
      this.$emit('close')
    },
  },
}
</script>

<style scoped lang="scss">
.yuanbao-author-rule-wrap {
  z-index: 30;
  position: relative;
  width: 531px;
  // height: 642px;
  height: 720px;
  // margin: 0 auto;
  background: #fff;
  border: 4px solid #f3c006;
  // box-shadow: 0px 10px 0px 0px rgba(168,132,0,0.3);
  border-radius: 12px;
  overflow: hidden;
  .btn-close {
    position: absolute;
    right: 8px;
    top: 8px;
    width: 20px;
    height: 20px;
    cursor: pointer;
    &:hover {
      &::before {
        background-position: -12px 0;
      }
    }
    &:active {
      &::before {
        background-position: -24px 0;
      }
    }
    &::before {
      content: '';
      display: inline-block;
      width: 12px;
      height: 12px;
      background: url('~@/assets/images/close2.png') 0 0 no-repeat;
    }
  }
  .bd {
    height: 720px;
    padding: 0 55px;
    margin: 0 auto;
    overflow: auto;
  }
  dl {
    padding-top: 40px;
    line-height: 24px;
    font-size: 14px;
    color: #5b1901;
  }
  dd {
    margin-bottom: 5px;
    padding-left: 8px;
  }
  .sub {
    padding-left: 8px;
  }
  p {
    margin: 0;
  }
}
</style>
